/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "dollar-cfd1ff28--sprite",
  "use": "dollar-cfd1ff28--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"dollar-cfd1ff28--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g transform=\"translate(0)\" fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><path d=\"M514.352,143.6H491.313a.722.722,0,0,0-.72.72v11.52a.722.722,0,0,0,.72.72h23.039a.722.722,0,0,0,.72-.72v-11.52A.722.722,0,0,0,514.352,143.6Zm-18.546,7.56a1.109,1.109,0,1,1,1.109-1.109A1.109,1.109,0,0,1,495.806,151.163Zm10.094,1.714a4.007,4.007,0,1,1,1.166-2.822A3.976,3.976,0,0,1,505.9,152.876Zm4.435-1.714a1.109,1.109,0,1,1,1.109-1.109A1.109,1.109,0,0,1,510.334,151.163Z\" transform=\"translate(-484.593 -131.605)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
